export const navLinksdata = [
  {
    _id: 1001,
    title: "Accueil",
    link: "home",
  },
  /*{
    _id: 1002,
    title: "Ma plus value",
    link: "features",
  },*/
  {
    _id: 1003,
    title: "Projets",
    link: "projects",
  },
  {
    _id: 1004,
    title: "Résumé",
    link: "resume",
  },

  {
    _id: 1006,
    title: "Contacts",
    link: "contact",
  },
];